export default {"src":"/_next/static/media/claim-tile.3791cf34.svg","height":240,"width":288};